var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('img',{attrs:{"src":_vm.imageSrc,"alt":"Ambulance Image"}}),(_vm.gps)?_c('img',{staticClass:"mt-n2",attrs:{"src":_vm.imageGpsSrc,"alt":"Ambulance  GPS"}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }